import { render } from "./Iti.vue?vue&type=template&id=9f9d8000"
import script from "./Iti.vue?vue&type=script&lang=js"
export * from "./Iti.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__